import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import reduce from 'lodash/reduce';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

import InnerHTML from '@Components/InnerHTML';
import {
  rsBuildingBlocksClassName,
  rsBuildingBlocksStartingMaterialsClassName,
  rsBuildingBlocksStepsCountClassName,
  rsBuildingBlocksProductClassName,
} from './RsBuildingBlocks';

export const ALIGN_CENTER_STARTING_MATERIALS = 'centerStartingMaterials';
export const ALIGN_CENTER_EVERYTHING = 'centerEverything';

function _getWidth(el) {
  return el ? Math.floor(el.offsetWidth) : 0;
}

function RsBuildingBlocksAlignment({ alignMode = ALIGN_CENTER_EVERYTHING, effectList = [], containerSelector }) {
  const buildingBlocksSelector = `.${rsBuildingBlocksClassName}`;
  const startingMaterialsSelector = `.${rsBuildingBlocksStartingMaterialsClassName}`;
  const stepsCountSelector = `.${rsBuildingBlocksStepsCountClassName}`;
  const productSelector = `.${rsBuildingBlocksProductClassName}`;
  const [offset, setOffset] = useState(undefined);

  // Align structures...
  const resizeHandler = () => {
    const containers = document.querySelectorAll(containerSelector);
    let minOffset;

    if (isEmpty(containers)) {
      return;
    }

    if (alignMode === ALIGN_CENTER_STARTING_MATERIALS) {
      minOffset = reduce(
        containers,
        (min, container) => {
          const sm = container.querySelector(startingMaterialsSelector);
          const sc = container.querySelector(stepsCountSelector);
          const pr = container.querySelector(productSelector);
          const extraWidth = _getWidth(container) - _getWidth(sm) - _getWidth(sc) - _getWidth(pr);
          const smOffset = extraWidth / 2;

          return isNil(min) ? smOffset : Math.min(min, smOffset);
        },
        null
      );
    } else {
      minOffset = reduce(
        containers,
        (min, container) => {
          const bb = container.querySelector(buildingBlocksSelector);
          const extraWidth = _getWidth(container) - _getWidth(bb);
          const bbOffset = extraWidth / 2;

          return isNil(min) ? bbOffset : Math.min(min, bbOffset);
        },
        null
      );
    }

    setOffset(Math.floor(minOffset));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(resizeHandler, effectList);

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    return () => window.removeEventListener('resize', resizeHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InnerHTML
      tag="style"
      html={
        alignMode === ALIGN_CENTER_STARTING_MATERIALS
          ? `${containerSelector} ${startingMaterialsSelector} { margin-right: ${offset}px; }`
          : `${containerSelector} ${buildingBlocksSelector} { margin-right: ${offset}px; }`
      }
    />
  );
}

RsBuildingBlocksAlignment.propTypes = {
  alignMode: PropTypes.oneOf([ALIGN_CENTER_STARTING_MATERIALS, ALIGN_CENTER_EVERYTHING]),
  effectList: PropTypes.array,
  containerSelector: PropTypes.string,
};

export default RsBuildingBlocksAlignment;
